import { useEffect, useState } from "react";

/**
 * Whether the page is scrolled further than `offset` pixels. With `once`, it stays true after the
 * first time, for things that fold away for good. React drops a state update that changes nothing,
 * so checking on every scroll event costs a comparison, not a render.
 */
export function useScrolledPast(offset: number, { once = false }: { once?: boolean } = {}): boolean {
  const [past, setPast] = useState(false);

  useEffect(() => {
    const check = () => {
      const beyond = window.scrollY > offset;
      setPast((previous) => (once ? previous || beyond : beyond));
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    return () => window.removeEventListener("scroll", check);
  }, [offset, once]);

  return past;
}
